export const UPDATE_SECTION_SETTINGS = 'REPORTING_UPDATE_SECTION_SETTINGS';

export const updateSectionSettings = settings => ({
  type: UPDATE_SECTION_SETTINGS,
  settings,
});
